import { c as _c } from "react/compiler-runtime";
import { IcoSparkles16 } from '@onefootprint/icons';
import type { ApiNodeDataWatchlistReview } from '@onefootprint/request-types/dashboard';
import { Form } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import BaseNode from '../base-node';
type WatchlistReviewFormData = {
  additionalInstructions?: string;
};
const WatchlistReviewNode = node => {
  const $ = _c(6);
  let t0;
  if ($[0] !== node.data) {
    t0 = {
      render: () => <Content nodeData={node.data} />
    };
    $[0] = node.data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== node.data || $[3] !== node.id || $[4] !== t0) {
    t1 = <BaseNode nodeId={node.id} data={node.data} sidebar={t0} />;
    $[2] = node.data;
    $[3] = node.id;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
const Content = t0 => {
  const $ = _c(28);
  const {
    nodeData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "watchlistReviewNode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const t2 = nodeData.additionalInstructions || "";
  let t3;
  if ($[1] !== t2) {
    t3 = {
      defaultValues: {
        additionalInstructions: t2
      }
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const formMethods = useForm(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IcoSparkles16 />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t) {
    t5 = t(_temp);
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <div className="flex gap-1">{t4}<p className="text-label-2">{t5}</p></div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t) {
    t7 = t(_temp2);
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <p className="text-body-2 text-secondary">{t7}</p>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8) {
    t9 = <div className="flex flex-col p-3 gap-2 border border-solid border-tertiary rounded-md">{t6}{t8}</div>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t(_temp3);
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t(_temp4);
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <Form.Textarea disabled={true} label={t10} name="additionalInstructions" placeholder={t11} />;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t9) {
    t13 = <div className="flex flex-col gap-6">{t9}{t12}</div>;
    $[22] = t12;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== formMethods || $[26] !== t13) {
    t14 = <FormProvider {...formMethods}>{t13}</FormProvider>;
    $[25] = formMethods;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};
export default WatchlistReviewNode;
function _temp($) {
  return $.whatWillPercyDo;
}
function _temp2($_0) {
  return $_0.percyReviewDescription;
}
function _temp3($_1) {
  return $_1.additionalInstructionsLabel;
}
function _temp4($_2) {
  return $_2.additionalInstructionsPlaceholder;
}